<template>
  <div>
    <base-screen>
      <el-form :inline="true" :model="param" label-position="left"
               class="demo-form-inline"
               ref="screenForm"
               @keydown.native.enter="searchSubmit"
               @submit.native.prevent>
        <el-form-item label="会员姓名：">
          <el-input v-model="param.name" placeholder="会员姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系方式：">
          <el-input v-model="param.phone" placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item label="会员卡号：">
          <el-input v-model="param.memberNo" placeholder="会员卡号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="searchSubmit">查询</el-button>
          <el-button type="text" @click="resetSearchSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <div class="tr">
        <!--<el-button>导入会员</el-button>-->
        <el-button type="primary" @click="$router.push({path: `${$route.path}/add`})" v-pms="'add'">添加会员</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableDataLoading"
        border
        style="width: 100%">
        <el-table-column
          fixed
          label="会员姓名"
          width="120">
          <template slot-scope="{row}">
            <el-button type="text" class="link" @click="$router.push({path: `${$route.path}/detail/${row.memberId}`})" v-pms="'look'">{{row.name}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="memberNo"
          label="会员卡号"
          width="150">
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          :formatter="handleSex"
          width="50">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="120">
        </el-table-column>
        <el-table-column
          prop="area"
          label="所属区域"
          width="150">
        </el-table-column>
        <el-table-column
          prop="addr"
          label="详细地址"
          width="200">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="$router.push({path: `${$route.path}/update/${scope.row.memberId}`})" type="text"
                       size="small" v-pms="'edit'">编辑
            </el-button>
            <el-button @click="deleteMember(`${scope.$index}`)" type="text" size="small" v-pms="'delete'">删除</el-button>
            <el-button @click="$router.push({name:'MemberRechargeManagement',params:{memberId:`${scope.row.memberId}`}})" type="text" size="small" v-pms="'charge'">充值</el-button>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageNum"
      :page-sizes="[10, 15, 20]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total">
    </el-pagination>
  </div>
</template>

<script>
import {member} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'
export default {
  name: 'MemberManagementList',
  data () {
    return {
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      param: {
        orgCode: getSession(ORG_CODE),
        name: '',
        phone: '',
        memberNo: ''
      },
      sexFlag: [{
        value: '1', name: '男'
      }, {
        value: '0', name: '女'
      }],
      tableDataLoading: false
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await member.pageMember({
        param: this.param,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    handleSex (row) {
      let result = this.sexFlag.find(item => item.value === row.sex)
      return result ? result.name : ''
    },
    searchSubmit () {
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.param.name = ''
      this.param.phone = ''
      this.param.memberNo = ''
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    memberCharge (index) {
    },
    deleteMember (index) {
      let memberId = this.tableData[index].memberId
      let name = this.tableData[index].name
      this.$confirm(`确定要删除会员[${name}]吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await member.delMember({
          'memberId': memberId
        })
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '会员删除成功'
          })
          this.tableData.splice(index, 1)
        } else {
          this.$message({
            type: 'error',
            message: msg || '会员删除失败'
          })
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
